import React, { useContext } from 'react';

import { ChartBarIcon, PlusIcon } from '@vlabs/icons';
import { Control, Panel } from '@vlabs/uikit';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { QueueCard } from '../queue-card/QueueCard';
import { QueueContext } from '../queue-context/QueueContext';
import st from './GroupCard.module.sass';

export function GroupCard({ groupName }) {
  const {
    streams,
    openGroupModal,
    openStreamModal,
    setActiveTab,
    setStreamIdsForStatistic } = useContext(QueueContext);
  const { t } = useTranslation();
  const resolvedGroupName = groupName === 'no_group' ? t('queue:queue group card.streams with no group') : groupName;

  const handleClickStatistic = () => {
    const streamsIdsInGroup = streams[groupName].map((s) => s.stream_id);
    setStreamIdsForStatistic([...streamsIdsInGroup]);
    setActiveTab('statistic');
  };

  return (
    <Panel
      className={classNames(st.GroupCardWrapper, 'PanelAutoHeight')}
    >
      <div className={st.GroupHeader}>
        <div className={st.GroupTitle}>{resolvedGroupName}</div>
        {groupName !== 'no_group' && (
          <div className={st.GroupButtons}>
            <Control.Button
              data-testid="GroupCard_statisticButton"
              icon={<ChartBarIcon />}
              kind="secondary"
              onClick={handleClickStatistic}
              variant="outlined"
            >
              {t('queue:queue group card.button section.statistics')}
            </Control.Button>
            <Control.Button
              data-testid="GroupCard_groupSettingsButton"
              kind="secondary"
              onClick={() => openGroupModal(groupName)}
              variant="outlined"
            >
              {t('queue:queue group card.button section.group settings')}
            </Control.Button>
            <Control.IconButton
              data-testid="GroupCard_createStreamButton"
              icon={<PlusIcon />}
              kind="secondary"
              onClick={() => openStreamModal(groupName)}
              shape="square"
              variant="outlined"
            />
          </div>
        )}
      </div>
      <div className={st.QueuesList}>
        {streams[groupName].map((stream) => (<QueueCard key={stream.stream_id} stream={stream} />))}
      </div>
    </Panel>
  );
}
